import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/800.css';
import '@eruvaka/web-pondlogs-i18n';
import { AppLayout } from './components/AppLayout';
import { AuthProvider } from './AuthContext';
import { theme } from './theme';
const container = document.getElementById('root');
if (!container)
    throw new Error('Root element #root not found');
const root = createRoot(container);
root.render(_jsx(StrictMode, { children: _jsx(BrowserRouter, { children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(AuthProvider, { children: _jsx(AppLayout, {}) })] }) }) }));
